import React, { useRef, useState } from 'react'
import { API_URL } from '../env'
import '../styles/Footer.css'
import { Col, Row } from 'react-bootstrap'
import logo from '../assets/logo.jpg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope, faHouse, faPaperPlane, faPen, faPhone, faUser } from '@fortawesome/free-solid-svg-icons'
import { Link } from 'react-router-dom'
import InputText from './Input/InputText'
import InputTextarea from './Input/InputTextarea'
import InputSwitch from './Input/InputSwitch'
import Button from './Utils/Button'
import { Fade } from 'react-awesome-reveal'
import { BrowserView, MobileView } from 'react-device-detect'
import { ThreeCircles } from 'react-loader-spinner'
import axios from 'axios'
import { toast } from 'react-toastify'

function Footer({ ip }) {

    const [isLoading, setIsLoading] = useState(false)
    const nameRef = useRef(null)
    const [name, setName] = useState("")
    const [nameError, setNameError] = useState(null)
    const phoneRef = useRef(null)
    const [phone, setPhone] = useState("")
    const [phoneError, setPhoneError] = useState(null)
    const emailRef = useRef(null)
    const [email, setEmail] = useState("")
    const [emailError, setEmailError] = useState(null)
    const messageRef = useRef(null)
    const [message, setMessage] = useState("")
    const [messageError, setMessageError] = useState(null)
    const [accept, setAccept] = useState(false)

    function sendContactQuote() {

        setIsLoading(true)
        var error = []
        if (!nameRef.current.nameValidation(name)) {
            error.push("Le nom est incorrect")
        }
        if (!phoneRef.current.phoneValidationOnBlur(phone)) {
            error.push("Le téléphone est incorrect")
        }
        if (!emailRef.current.emailValidationOnBlur(email)) {
            error.push("L'email est incorrect")
        }
        if (!messageRef.current.textValidation(message)) {
            error.push("Le message est incorrect")
        }
        const typeFormat = "Quote"
        if (error.length > 0) {
            error.map((item) => toast.error(item))
            setIsLoading(false)
        } else {
            const toastId = toast.loading("Envois...")
            axios.post(API_URL + "contact", {
                type: typeFormat,
                name: name,
                phone: phone,
                email: email,
                message: message,
                ip: ip
            }).then((response) => {
                if (response.data === "CONTACT_SEND") {
                    toast.update(toastId, { render: "Demande de rappel envoyée", type: "success", isLoading: false, closeButton: true, closeOnClick: true, autoClose: 5000 })
                    setName("")
                    setNameError(null)
                    setPhone("")
                    setPhoneError(null)
                    setEmail("")
                    setEmailError(null)
                    setMessage("")
                    setMessageError(null)
                    setAccept(false)
                }
                setIsLoading(false)
            }).catch((error) => {
                if (error.response) {
                    var errorMessage = error.response.data.message
                    if (errorMessage === "ERROR_CONTACT_CREATION" || errorMessage === "ERROR_UPDATE_CONTACT") {
                        errorMessage = "Erreur lors de la création du message"
                    } else if (errorMessage === "ERROR_SENDING_EMAIL") {
                        errorMessage = "Erreur lors de l'envoi du message"
                    }
                }
                toast.update(toastId, { render: errorMessage, type: "error", isLoading: false, closeButton: true, closeOnClick: true, autoClose: 5000 })
                setIsLoading(false)
            })
        }

    }

    return (

        <>
            <BrowserView>
                <div id='footer'>
                    <Row>
                        <Col sm={4} id='footerInfo'>
                            <Fade direction={'left'} duration={500}>
                                <div id='footerTitle'>Coordonnées</div>
                                <img src={logo} id='footerInfoLogo' alt='logo' />
                                <div className='footerInfoRow'>
                                    <FontAwesomeIcon icon={faPhone} className='footerInfoRowIcon' />
                                    06 58 80 21 34
                                </div>
                                <div className='footerInfoRow'>
                                    <FontAwesomeIcon icon={faEnvelope} className='footerInfoRowIcon' />
                                    contact@e5mdiagnostics.fr
                                </div>
                                <div className='footerInfoRow'>
                                    <FontAwesomeIcon icon={faHouse} className='footerInfoRowIcon' />
                                    4 rue Pierre Brossolette, 92700 Colombes
                                </div>
                            </Fade>
                        </Col>
                        <Col sm={3} id='footerLink'>
                            <Fade direction={'bottom'} duration={500}>
                                <div id='footerLinks'>
                                    <div id='footerTitle'>Lien utiles</div>
                                    <Link to='/mentions-légales' className='footerLinkItem' onClick={() => window.scrollTo({ top: 0, behavior: 'instant' })}>Mentions légales</Link>
                                    <Link to='/contact' className='footerLinkItem' onClick={() => window.scrollTo({ top: 0, behavior: 'instant' })}>Contact</Link>
                                </div>
                            </Fade>
                        </Col>
                        <Col sm={5} id='footerQuote'>
                            <div id='footerTitle'>Devis gratuit</div>
                            <Fade direction={'right'} duration={500}>
                                <Row>
                                    <Col>
                                        <InputText
                                            type={'name'}
                                            theme={'light'}
                                            ref={nameRef}
                                            text={name} setText={setName}
                                            textError={nameError} setTextError={setNameError}
                                            icon={<FontAwesomeIcon icon={faUser} />}
                                            placeholder={"Nom"}
                                            maxLength={32}
                                            onPressEnter={() => phoneRef.current.inputTextRef.current.focus()}
                                        />
                                    </Col>
                                    <Col>
                                        <InputText
                                            type={'phone'}
                                            theme={'light'}
                                            ref={phoneRef}
                                            text={phone} setText={setPhone}
                                            textError={phoneError} setTextError={setPhoneError}
                                            icon={<FontAwesomeIcon icon={faPhone} />}
                                            placeholder={"Téléphone"}
                                            maxLength={14}
                                            onPressEnter={() => emailRef.current.inputTextRef.current.focus()}
                                        />
                                    </Col>
                                </Row>
                            </Fade>
                            <Fade direction={'right'} duration={500} delay={50}>
                                <Row>
                                    <Col>
                                        <InputText
                                            type={'email'}
                                            theme={'light'}
                                            ref={emailRef}
                                            text={email} setText={setEmail}
                                            textError={emailError} setTextError={setEmailError}
                                            icon={<FontAwesomeIcon icon={faEnvelope} />}
                                            placeholder={"Email"}
                                            maxLength={128}
                                            onPressEnter={() => messageRef.current.inputTextareaRef.current.focus()}
                                        />
                                    </Col>
                                </Row>
                            </Fade>
                            <Fade direction={'right'} duration={500} delay={100}>
                                <Row>
                                    <Col>
                                        <InputTextarea
                                            theme={'light'}
                                            ref={messageRef}
                                            text={message} setText={setMessage}
                                            textError={messageError} setTextError={setMessageError}
                                            icon={<FontAwesomeIcon icon={faPen} />}
                                            placeholder={"Message"}
                                            nbRow={6}
                                        />
                                    </Col>
                                </Row>
                            </Fade>
                            <Fade direction={'right'} duration={500} delay={150}>
                                <InputSwitch
                                    theme={'light'}
                                    value={accept} setValue={setAccept}
                                    label={"En soumettant ce formulaire, j'accepte que les informations saisies soient exploitées dans le cadre de la relation professionnelle confidentielle."}
                                />
                            </Fade>
                            <Fade direction={'right'} duration={500} delay={200}>
                                <div id='footerQuoteFormButton'>
                                    {!isLoading ?
                                        <Button theme={'light'} icon={<FontAwesomeIcon icon={faPaperPlane} />} text={"Envoyer"} rounded={true} disabled={!accept} onClick={() => sendContactQuote()} />
                                        :
                                        <ThreeCircles visible={true} height={"40"} width={"40"} color={getComputedStyle(document.documentElement).getPropertyValue('--loaderLight')} />
                                    }
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                </div >
            </BrowserView >

            <MobileView>
                <div id='footerMobile'>
                    <div sm={4} id='footerInfoMobile'>
                        <Fade direction={'left'} duration={500}>
                            <div id='footerTitle'>Coordonnées</div>
                            <img src={logo} id='footerInfoLogo' alt='logo' />
                            <div className='footerInfoRow'>
                                <FontAwesomeIcon icon={faPhone} className='footerInfoRowIcon' />
                                06 58 80 21 34
                            </div>
                            <div className='footerInfoRow'>
                                <FontAwesomeIcon icon={faEnvelope} className='footerInfoRowIcon' />
                                contact@e5mdiagnostics.fr
                            </div>
                            <div className='footerInfoRow'>
                                <FontAwesomeIcon icon={faHouse} className='footerInfoRowIcon' />
                                4 rue Pierre Brossolette, 92700 Colombes
                            </div>
                        </Fade>
                    </div>
                    <div sm={3} id='footerLinkMobile'>
                        <Fade direction={'bottom'} duration={500}>
                            <div id='footerLinks'>
                                <div id='footerTitle'>Lien utiles</div>
                                <Link to='/mentions-légales' className='footerLinkItem' onClick={() => window.scrollTo({ top: 0, behavior: 'instant' })}>Mentions légales</Link>
                                <Link to='/contact' className='footerLinkItem' onClick={() => window.scrollTo({ top: 0, behavior: 'instant' })}>Contact</Link>
                            </div>
                        </Fade>
                    </div>
                    <div id='footerQuote'>
                        <div id='footerTitle'>Devis gratuit</div>
                        <Fade direction={'left'} duration={500}>
                            <Row>
                                <Col>
                                    <InputText
                                        type={'name'}
                                        theme={'light'}
                                        ref={nameRef}
                                        text={name} setText={setName}
                                        textError={nameError} setTextError={setNameError}
                                        icon={<FontAwesomeIcon icon={faUser} />}
                                        placeholder={"Nom"}
                                        maxLength={32}
                                        onPressEnter={() => phoneRef.current.inputTextRef.current.focus()}
                                    />
                                </Col>
                            </Row>
                        </Fade>
                        <Fade direction={'right'} duration={500} delay={50}>
                            <Row>
                                <Col>
                                    <InputText
                                        type={'phone'}
                                        theme={'light'}
                                        ref={phoneRef}
                                        text={phone} setText={setPhone}
                                        textError={phoneError} setTextError={setPhoneError}
                                        icon={<FontAwesomeIcon icon={faPhone} />}
                                        placeholder={"Téléphone"}
                                        maxLength={14}
                                        onPressEnter={() => emailRef.current.inputTextRef.current.focus()}
                                    />
                                </Col>
                            </Row>
                        </Fade>
                        <Fade direction={'left'} duration={500} delay={100}>
                            <Row>
                                <Col>
                                    <InputText
                                        type={'email'}
                                        theme={'light'}
                                        ref={emailRef}
                                        text={email} setText={setEmail}
                                        textError={emailError} setTextError={setEmailError}
                                        icon={<FontAwesomeIcon icon={faEnvelope} />}
                                        placeholder={"Email"}
                                        maxLength={128}
                                        onPressEnter={() => messageRef.current.inputTextareaRef.current.focus()}
                                    />
                                </Col>
                            </Row>
                        </Fade>
                        <Fade direction={'right'} duration={500} delay={150}>
                            <Row>
                                <Col>
                                    <InputTextarea
                                        theme={'light'}
                                        ref={messageRef}
                                        text={message} setText={setMessage}
                                        textError={messageError} setTextError={setMessageError}
                                        icon={<FontAwesomeIcon icon={faPen} />}
                                        placeholder={"Message"}
                                        nbRow={6}
                                    />
                                </Col>
                            </Row>
                        </Fade>
                        <Fade direction={'left'} duration={500} delay={200}>
                            <InputSwitch
                                value={accept} setValue={setAccept}
                                label={"En soumettant ce formulaire, j'accepte que les informations saisies soient exploitées dans le cadre de la relation professionnelle confidentielle."}
                            />
                        </Fade>
                        <Fade direction={'left'} duration={500} delay={250}>
                            <div id='footerQuoteFormButton'>
                                {!isLoading ?
                                    <Button theme={'light'} icon={<FontAwesomeIcon icon={faPaperPlane} />} text={"Envoyer"} rounded={true} disabled={!accept} onClick={() => sendContactQuote()} />
                                    :
                                    <ThreeCircles visible={true} height={"40"} width={"40"} color={getComputedStyle(document.documentElement).getPropertyValue('--loaderLight')} />
                                }
                            </div>
                        </Fade>
                    </div>
                </div>
            </MobileView >
        </>

    )

}

export default Footer